import type { AbandonedCheckoutListParams } from '../api/abandoned-checkouts-api';

/** Store-scoped keys: switching stores never shares cache. */
export const abandonedCheckoutKeys = {
  all: (storeId: string) => ['stores', storeId, 'abandoned-checkouts'] as const,
  lists: (storeId: string) => [...abandonedCheckoutKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: AbandonedCheckoutListParams) =>
    [...abandonedCheckoutKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...abandonedCheckoutKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...abandonedCheckoutKeys.details(storeId), id] as const,
};
